exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icon__1rSy2{display:inline-block;height:1.2em;width:1.2em}.icon__1rSy2 svg{max-width:100%;width:100%;max-height:100%}", "", {"version":3,"sources":["/home/transit-alerts-widget/checkout/transit-alerts-widget/src/components/Icons/styles.scss"],"names":[],"mappings":"AAAA,aACI,qBACA,aACA,WAAY,CAHhB,iBAKQ,eACA,WACA,eAAgB,CACnB","file":"styles.scss","sourcesContent":[".icon {\n    display: inline-block;\n    height: 1.2em;\n    width: 1.2em;\n    svg {\n        max-width: 100%;\n        width: 100%;\n        max-height: 100%;\n    }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "icon__1rSy2"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/Icons/styles.scss
// module id = PTXe
// module chunks = 0